export enum PaymentStatus{
    ScheduledToPay = 'ScheduledToPay',
    Paid = 'Paid'
}